export default "__VITE_ASSET__d549b30d__"